import styled from "styled-components";
import { NavLink } from "react-router-dom";

export const Container = styled.header`
    width: 100%;
    position: sticky;
    top: 0;
    z-index: 1000;
    background: white;
    box-shadow: ${({ $scrolled }) => ($scrolled ? "0 2px 8px rgba(0,0,0,0.1)" : "none")};
    transition: all 0.3s ease;
    border-bottom: 1px solid #ededed;
    @media screen and (max-width: 1140px){
        position: relative;
    }
`;

export const Wrap = styled.div`
    max-width: 1140px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: 0.2s;
    @media screen and (max-width: 1140px){
        padding: 0 20px;
    }
`;

export const Logo = styled(NavLink)`
    width: ${({ $scrolled }) => ($scrolled ? "126px" : "238px")};
    height: ${({ $scrolled }) => ($scrolled ? "55px" : "90px")};
    display: block;
    background-image: url(${({ $logoUrl }) => $logoUrl || ""});
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    transition: all 0.3s ease;
`;

export const NavWrap = styled.div`
    display: flex;
    align-items: center;
    gap: 40px;
    @media screen and (max-width: 1140px){
        display: none;
    }
`;

export const Link = styled(NavLink)`
    color: #444444;
    font-size: 14px;
    font-weight: bold;
    text-transform: uppercase;
    text-decoration: none;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    transition: 0.2s;
    &.active::after,
    &:hover::after {
        width: 100%;
        @media screen and (max-width: 1140px){
            width: 0;
        }
    }

    &::after {
        position: absolute;
        content: "";
        bottom: -5px;
        left: 0;
        width: 0;
        background-color: #00a0e7;
        height: 3px;
        transition: all 0.2s ease-in-out;
        
    }
    @media screen and (max-width: 1140px){
        width: 100%;
        border-bottom: 1px solid #ededed;
        padding: 20px;
        justify-content: start;
        font-size: 13px;
    }
`;

export const Icon = styled.img``;

export const Burger = styled.img`
    display: none;
    cursor: pointer;
    transition: 0.2s;
    @media screen and (max-width: 1140px){
        display: block;
    }
`;

export const FixedBtnWrap = styled.div`
    position: fixed;
    right: 10px;
    bottom: 10px;
    z-index: 1;
    display: flex;
    transition: 0.2s;
    gap: ${({$isScrolled})=>$isScrolled?'10px':'0'};
`
export const EmailBtn = styled.a`
    height: 45px;
    width: 45px;
    cursor: pointer;
    background-color: rgba(0, 0, 0, .4);
    transition: all 0.3s ease-in-out;
    display: flex;
    justify-content: center;
    align-items: center;
    & > svg{
       fill: white; 
    }
    &:hover {
        opacity: 1;
        transform: translateY(-3px);
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);
        background-color: #00a0e7;
    }
`
export const ScrollTopBtn = styled.button`
    background-color: rgba(0, 0, 0, .2);
    height: 45px;
    border: none;
    cursor: pointer;
    overflow: hidden;
    width: ${({$isScrolled})=>$isScrolled?'45px':'0'};
    opacity: ${({$isScrolled})=>$isScrolled?'1':'0'};
    translate: ${({$isScrolled})=>$isScrolled?'0':'20px'};
    transition: all 0.3s ease-in-out;
    
    &:hover {
        opacity: 1;
        transform: translateY(-3px);
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);
        background-color: rgba(0,0,0,.3)
    }
`;
export const ArrowIcon = styled.svg`
    fill: white;
`
